import React from 'react';
import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { translate } from '../../../../types/translation/Translator';
import { FilterProps, FilterStorageKey } from '../common/filter.util';
import { Company } from '../../../../types/company';
import { itemsContainText } from '../../../../util/string.util';
import { CompanyStatusFilter } from '../CompanyStatusFilter/CompanyStatusFilter';

export class CompanyFilter extends BaseFilter<Company> {
  constructor(storageKey?: FilterStorageKey) {
    super(storageKey);
  }

  filterOptions(): BaseFilter<any>[] {
    return [new CompanyStatusFilter()];
  }

  toLabel(): string {
    return translate({ key: TranslationKey.company });
  }

  toCount(props: BaseFilterProps): number {
    let total = 0;
    if (props.filterProps.companyStatus?.size) total++;
    return total;
  }

  toIcon(): JSX.Element {
    return <></>;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return <></>;
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return <></>;
  }

  search(item: Company, query: string) {
    return itemsContainText(query, [item.name]);
  }

  filteredItems(items: Company[], query: string, filterProps: FilterProps) {
    return items.filter(item => {
      return [CompanyFilter.filter(filterProps, item), this.search(item, query)].every(
        value => value === null || value,
      );
    });
  }

  static filter(filterProps: FilterProps, item: Company | undefined) {
    if (item && filterProps.companyStatus?.size && !filterProps.companyStatus.has(item.status)) return false;
    return true;
  }
}
